<template>
  <div>
    <div
      ref="inputWrapper"
      :style="{ borderColor: this.state || this.state === null ? '#ACAEBD' : 'red' }"
      class="drag-area"
    >
      <div class="hint">
        <div>
          <component :is="icons.Upload" class="mr-2" />
        </div>
        <div class="hint__label">
          {{ hint }}
        </div>
      </div>
    </div>
    <b-form-file ref="inputForm" :accept="accept" class="input-file" multiple @change="onChangeFile"></b-form-file>
  </div>
</template>

<script>
import icons from "@/assets/icons";

export default {
  model: {
    event: "change"
  },
  props: {
    value: {
      default: undefined
    },
    accept: {
      type: String,
      default: ""
    },
    state: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    dropPlaceholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      rawValue: this.value,
      icons,
      hint: "",
      selectedFiles: []
    };
  },
  methods: {
    fileToDataUrl(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = event => {
          resolve(event.target.result);
        };
        reader.onerror = error => reject(error);
        reader.readAsDataURL(file);
      });
    },
    async onChangeFile(event) {
      const files = [];
      for (const file of event.target.files) {
        files.push(this.someFileProps(file));
      }
      this.$emit("change", [...this.value, ...files]);
    },
    someFileProps(file) {
      file.format = file.type;
      file.extension = file.name.split(".").pop();
      file.sizeInBytes = file.size;
      file.sizeInKB = (file.size / 1024).toFixed(2);
      file.sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

      return {
        file,
        url: URL.createObjectURL(file),
        name: file.name,
        format: file.format,
        extension: file.extension,
        sizeInBytes: file.sizeInBytes,
        sizeInKB: file.sizeInKB,
        sizeInMB: file.sizeInMB
      };
    }

  },
  mounted() {
    this.hint = this.placeholder;
    this.$refs.inputWrapper.addEventListener('click', () => {
      this.$refs.inputForm.$refs.input.click();
    });

    this.$refs.inputWrapper.addEventListener('drop', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.hint = this.placeholder;
      const files = [];
      for (const file of e.dataTransfer.files) {
        files.push(this.someFileProps(file));
      }
      this.$emit("change", [...this.value, ...files]);
    });

    this.$refs.inputWrapper.addEventListener('dragover', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.hint = this.dropPlaceholder;
    });

    this.$refs.inputWrapper.addEventListener('dragleave', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.hint = this.placeholder;
    });
  }
};
</script>

<style scoped lang="scss">
.drag-area {
  height: 8rem;
  width: 100%;
  background: #f4f7fa;
  border: 2px dashed #acaebd;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;

  .hint {
    font-family: "Lato";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #6c7589;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.input-file {
  visibility: hidden;
}
</style>
